module.exports = __webpack_public_path__ + "img/social04.412585a6.svg";